import React from 'react';
import { clsx } from 'clsx';
import SafeIcon from '../common/SafeIcon';

const glowColors = {
  red: 'glass-btn--red',
  blue: 'glass-btn--blue',
  green: 'glass-btn--green',
  gold: 'glass-btn--gold',
  navy: 'glass-btn--navy',
};

export const GlassButton = ({
  children,
  glow = 'blue',
  size = 'md',
  icon,
  iconPosition = 'left',
  href,
  className,
  ...props
}) => {
  const sizes = {
    sm: 'glass-btn--sm',
    md: 'glass-btn--md',
    lg: 'glass-btn--lg',
  };

  const Tag = href ? 'a' : 'button';
  const linkProps = href ? { href } : {};

  return (
    <div className={clsx('glass-btn', glowColors[glow], sizes[size], className)}>
      <Tag className="glass-btn__inner" {...linkProps} {...props}>
        {icon && iconPosition === 'left' && <SafeIcon icon={icon} className="glass-btn__icon" />}
        <span>{children}</span>
        {icon && iconPosition === 'right' && <SafeIcon icon={icon} className="glass-btn__icon" />}
      </Tag>
    </div>
  );
};

export default GlassButton;
